import vtkAngleWidget from './AngleWidget';
import vtkEllipseWidget from './EllipseWidget';
import vtkImageCroppingWidget from './ImageCroppingWidget';
import vtkImplicitPlaneWidget from './ImplicitPlaneWidget';
import vtkInteractiveOrientationWidget from './InteractiveOrientationWidget';
import vtkLabelWidget from './LabelWidget';
import vtkLineWidget from './LineWidget';
import vtkPaintWidget from './PaintWidget';
import vtkPolyLineWidget from './PolyLineWidget';
import vtkRectangleWidget from './RectangleWidget';
import vtkResliceCursorWidget from './ResliceCursorWidget';
import vtkShapeWidget from './ShapeWidget';
import vtkSphereWidget from './SphereWidget';
import vtkSplineWidget from './SplineWidget';

export default {
  vtkAngleWidget,
  vtkEllipseWidget,
  vtkImageCroppingWidget,
  vtkImplicitPlaneWidget,
  vtkInteractiveOrientationWidget,
  vtkLabelWidget,
  vtkLineWidget,
  vtkPaintWidget,
  vtkPolyLineWidget,
  vtkRectangleWidget,
  vtkResliceCursorWidget,
  vtkShapeWidget,
  vtkSphereWidget,
  vtkSplineWidget,
};
